import { Box, styled } from "@mui/material";
import { getUnixTime } from "date-fns";
import { useState } from "react";

import { DashboardChartLegend } from "./components/Legend";
import { DateFilter } from "./components/DateFilter";
import { useGetChartQuery } from "api/charts";
import { StatusFilter } from "./components/StatusFilter";
import { SourceFilter, DATA_SOURCE_TYPES } from "./components/SourceFilter";
import { YAxisFilter, Y_AXIS_TYPES } from "./components/YAxisFilter";
import { ChartLoadingSkeleton } from "./components/ChartLoadingSkeleton";
import { BarChart } from "./components/BarChart";

const Wrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const NoDataDisplay = styled(Box)(() => ({
  height: 300,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#fafafa",
  border: "1px dashed #ccc",
  borderRadius: "12px",
}));

export const DataChart = () => {
  const [source, setSource] = useState(DATA_SOURCE_TYPES.bank);
  const [status, setStatus] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [yAxisKey, setYAxisKey] = useState(Y_AXIS_TYPES.AMOUNT);

  const { data, isLoading } = useGetChartQuery({ to, from, status, source });
  const chart = data?.data?.metrics || [];

  const handleSelectRange = ({ startDate, endDate }) => {
    setFrom(startDate ? getUnixTime(startDate) : null);
    setTo(endDate ? getUnixTime(endDate) : null);
  };

  const handleSourceChange = (newSource) => {
    setSource(newSource);
  };

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
  };

  return (
    <Box>
      <Wrapper
        sx={{
          justifyContent: "space-between",
          marginBottom: 3,
          paddingTop: "40px",
        }}
      >
        <DashboardChartLegend />
        <Wrapper sx={{ columnGap: "8px" }}>
          <SourceFilter
            onSourceChange={handleSourceChange}
            selectedSource={source}
          />
          <StatusFilter
            selectedStatus={status}
            onStatusChange={handleStatusChange}
          />
          <DateFilter handleSelectRange={handleSelectRange} />
        </Wrapper>
      </Wrapper>
      <Wrapper sx={{ columnGap: "15px" }}>
        <YAxisFilter yAxisKey={yAxisKey} setYAxisKey={setYAxisKey} />
      </Wrapper>
      {(() => {
        if (isLoading) {
          return <ChartLoadingSkeleton />;
        } else if (chart.length === 0) {
          return (
            <NoDataDisplay>
              <Box sx={{ textAlign: "center", color: "#999" }}>
                <Box>No data available for this selection</Box>
              </Box>
            </NoDataDisplay>
          );
        } else {
          return <BarChart source={source} yAxisKey={yAxisKey} data={chart} />;
        }
      })()}
    </Box>
  );
};
